import axios from '@/api/config';

const specialExercise = {
  getSpecialExerciseById(data) {
    return axios.get(`${process.env.BASE_URL}/specialExercise/getSpecialExerciseById/` + data, {});
  },
  getSpecialExerciseDetail(data) {
    return axios.get(`${process.env.BASE_URL}/specialExercise/getSpecialExerciseDetail`, {params: data});
  },
  getSpecialExercise(data) {
    return axios.get(`${process.env.BASE_URL}/specialExercise/getSpecialExercise`, {params: data});
  },
  getSpecialExerciseList(data) {
    return axios.get(`${process.env.BASE_URL}/specialExercise/getSpecialExerciseList`, {params: data});
  },
  getSpecialExerciseTree(data) {
    return axios.get(`${process.env.BASE_URL}/specialExercise/getSpecialExerciseTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/specialExercise/pageList`, data);
  },
  addSpecialExercise(data) {
    return axios.post(`${process.env.BASE_URL}/specialExercise/addSpecialExercise`, data);
  },
  updateSpecialExercise(data) {
    return axios.put(`${process.env.BASE_URL}/specialExercise/updateSpecialExercise`, data);
  },
  deleteSpecialExercise(data) {
    return axios.delete(`${process.env.BASE_URL}/specialExercise/deleteSpecialExercise`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/specialExercise/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/specialExercise/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/specialExercise/active`, data);
  },
}

export default specialExercise;



// WEBPACK FOOTER //
// ./src/api/specialExercise.js